import * as React from 'react';

import Spacer from 'components/atoms/Spacer';

import type { Notification } from 'components/notification/type';
import Paginator from 'components/notification/components/Paginator';
import NotificationCardList from './components/NotificationCardList';
import EmptyNotificationMessage from './components/EmptyNotificationMessage';
import cs from './NotificationListPageView.scss';

export type Props = {
  notifications: Notification[] | null;
  currentPage: number;
  totalPage: number | null;
  changePage: (newPage: number) => void;
};

export const NotificationListPageView: React.FC<Props> = React.memo(
  ({ notifications, currentPage, totalPage, changePage }) => (
    <div className={cs['container']}>
      <Spacer size={25} />
      <div className={cs['title']}>あなたへのお知らせ</div>
      <Spacer size={24} />
      {notifications === null ? (
        <div className={cs['blank-space']} />
      ) : notifications.length !== 0 ? (
        <NotificationCardList notifications={notifications} />
      ) : (
        <EmptyNotificationMessage />
      )}
      <Spacer size={20} />
      {notifications !== null && totalPage !== null && notifications.length !== 0 ? (
        <Paginator
          currentPage={currentPage}
          maxPage={totalPage}
          changePage={changePage}
          arrowSize="wide"
        />
      ) : null}
      <Spacer size={20} />
    </div>
  )
);

NotificationListPageView.displayName = 'NotificationListPageView';

export default NotificationListPageView;
